import React from 'react';

import { Typography } from '@mui/material';
import { Field } from 'react-final-form';

import { RentalPriceID } from '@kamernet/core/ApiClient/Kamernet';
import { useIntl } from '@kamernet/core/Intl';

import { MaxRentInput } from '../MaxRentInput';

export const MaxRentFormField = () => {
  const { T } = useIntl();

  return (
    <React.Fragment>
      <Typography variant="h4">{T('LBL_NEW_ALERT_RENTAL_PRICE')}</Typography>
      <Field<RentalPriceID> name="maxRent">
        {({ input }) => {
          return (
            <MaxRentInput
              size="small"
              variant="outlined"
              value={input.value}
              onChange={input.onChange}
            />
          );
        }}
      </Field>
    </React.Fragment>
  );
};
